module.exports = __webpack_public_path__ + "img/ec.29cdaa6a.svg";